// Auto-extracted constant data for VIFRulesMulDiv.ts.
// Pure structural refactor: literal arrays only, verbatim copies of the
// original inline literals. No behavioral change.

export const RULES_MUL_DIV_GPR = [1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1];

export const RULES_MUL_DIV_ROUNDS = [2, 4, 2, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4];

export const RULES_MUL_DIV_NINES = [7, 14, 20, 25, 29, 32, 34, 35];

export const RULES_MUL_DIV_EIGHTS = [6, 13, 19, 24, 28, 31, 33];

export const RULES_MUL_DIV_SEVENS = [5, 12, 18, 23, 27, 30];

export const RULES_MUL_DIV_SIXES = [4, 11, 17, 22, 26];

export const RULES_MUL_DIV_OTHERS = [0, 1, 2, 3, 8, 9, 10, 15, 16, 21];

const flag0StartSeconds = [0, 60, 60, 60];

const flag1StartSeconds = [0, 0, 0, 0];

const flag2StartSeconds = [0, 60, 60, 60];

const flag3StartSeconds = [0, 0, 0, 0];

const flag4StartSeconds = [0, 0, 60, 45];

const flag5StartSeconds = [0, 0, 0, 0];

const flag6StartSeconds = [0, 75, 60, 45];

const flag7StartSeconds = [0, 75, 60, 45];

const flag8StartSeconds = [0, 75, 60, 45];

const flag10StartSeconds = [0, 60, 60, 60];

const flag11StartSeconds = [0, 0, 0, 0];

const flag12StartSeconds = [0, 60, 60, 60];

const flag13StartSeconds = [0, 0, 0, 0];

const flag14StartSeconds = [0, 75, 60, 45];

const flag15StartSeconds = [0, 0, 0, 0];

const flag16StartSeconds = [0, 75, 60, 45];

const flag0Round1Layer1TopEQs = ['1 × 2', '4 × 1', '1 × 6', '1 × 9'];

const flag0Round1Layer1BottomAnswers = ['2', '4', '6', '9'];

const flag0Round1Layer2TopEQs = ['1 × 1', '9 × 1', '1 × 3', '6 × 1'];

const flag0Round1Layer2BottomAnswers = ['1', '9', '3', '6'];

const flag0Round1Layer3TopEQs = ['1 × 5', '8 × 1', '1 × 4', '7 × 1'];

const flag0Round1Layer3BottomAnswers = ['5', '8', '4', '7'];

const flag0Round1Layer4TopEQs = [
  '2 × 1',
  '9 × 0',
  '1 × 7',
  '1 × 0',
  '3 × 1',
  '0 × 2',
  '5 × 1',
  '0 × 6',
  '1 × 8',
];

const flag0Round1Layer4BottomAnswers = [
  '2',
  '0',
  '7',
  '0',
  '3',
  '0',
  '5',
  '0',
  '8',
];

const flag0Round2Layer1TopEQs = ['9 × 1', '1 × 4', '1 × 2', '5 × 1'];

const flag0Round2Layer1BottomAnswers = ['9', '4', '2', '5'];

const flag0Round2Layer2TopEQs = [
  '0 × 8',
  '1 × 9',
  '3 × 0',
  '8 × 1',
  '0 × 1',
  '1 × 1',
  '3 × 1',
  '0 × 3',
  '6 × 1',
];

const flag0Round2Layer2BottomAnswers = [
  '0',
  '9',
  '0',
  '8',
  '0',
  '1',
  '3',
  '0',
  '6',
];

const flag0Round2Layer3TopEQs = ['4 × 1', '1 × 5', '1 × 6', '1 × 7'];

const flag0Round2Layer3BottomAnswers = ['4', '5', '6', '7'];

const flag0Round2Layer4TopEQs = ['1 × 3', '1 × 8', '2 × 1', '7 × 1'];

const flag0Round2Layer4BottomAnswers = ['3', '8', '2', '7'];

const flag1Round1Layer1TopEQs = [
  '10 × 10',
  '10 × 30',
  '10 × 40',
  '10 × 50',
  '10 × 60',
  '10 × 70',
  '10 × 80',
  '10 × 90',
  '20 × 20',
];

const flag1Round1Layer1BottomAnswers = [
  '100',
  '300',
  '400',
  '500',
  '600',
  '700',
  '800',
  '900',
  '400',
];

const flag1Round1Layer2TopEQs = [
  '20 × 30',
  '20 × 40',
  '20 × 50',
  '20 × 60',
  '20 × 70',
  '20 × 80',
  '20 × 90',
  '30 × 20',
  '30 × 30',
];

const flag1Round1Layer2BottomAnswers = [
  '600',
  '800',
  '1000',
  '1200',
  '1400',
  '1600',
  '1800',
  '600',
  '900',
];

const flag1Round1Layer3TopEQs = [
  '30 × 40',
  '30 × 50',
  '30 × 60',
  '30 × 70',
  '30 × 80',
  '30 × 90',
  '40 × 10',
  '40 × 30',
  '40 × 40',
];

const flag1Round1Layer3BottomAnswers = [
  '1200',
  '1500',
  '1800',
  '2100',
  '2400',
  '2700',
  '400',
  '1200',
  '1600',
];

const flag1Round1Layer4TopEQs = [
  '40 × 50',
  '40 × 60',
  '40 × 70',
  '40 × 80',
  '40 × 90',
  '50 × 20',
  '50 × 30',
  '50 × 40',
  '50 × 50',
];

const flag1Round1Layer4BottomAnswers = [
  '2000',
  '2400',
  '2800',
  '3200',
  '3600',
  '1000',
  '1500',
  '2000',
  '2500',
];

const flag1Round2Layer1TopEQs = [
  '50 × 60',
  '50 × 70',
  '50 × 80',
  '50 × 90',
  '60 × 10',
  '60 × 30',
  '60 × 40',
  '60 × 50',
  '60 × 60',
];

const flag1Round2Layer1BottomAnswers = [
  '3000',
  '3500',
  '4000',
  '4500',
  '600',
  '1800',
  '2400',
  '3000',
  '3600',
];

const flag1Round2Layer2TopEQs = [
  '60 × 70',
  '60 × 80',
  '60 × 90',
  '70 × 20',
  '70 × 30',
  '70 × 40',
  '70 × 50',
  '70 × 60',
  '70 × 70',
];

const flag1Round2Layer2BottomAnswers = [
  '4200',
  '4800',
  '5400',
  '1400',
  '2100',
  '2800',
  '3500',
  '4200',
  '4900',
];

const flag1Round2Layer3TopEQs = [
  '70 × 80',
  '70 × 90',
  '80 × 10',
  '80 × 30',
  '80 × 40',
  '80 × 50',
  '80 × 60',
  '80 × 70',
  '80 × 80',
];

const flag1Round2Layer3BottomAnswers = [
  '5600',
  '6300',
  '800',
  '2400',
  '3200',
  '4000',
  '4800',
  '5600',
  '6400',
];

const flag1Round2Layer4TopEQs = [
  '80 × 90',
  '90 × 20',
  '90 × 30',
  '90 × 40',
  '90 × 50',
  '90 × 60',
  '90 × 70',
  '90 × 80',
  '90 × 90',
];

const flag1Round2Layer4BottomAnswers = [
  '7200',
  '1800',
  '2700',
  '3600',
  '4500',
  '5400',
  '6300',
  '7200',
  '8100',
];

const flag1Round3Pool1 = [
  '10 × 10',
  '10 × 30',
  '10 × 50',
  '10 × 70',
  '10 × 90',
  '20 × 20',
  '20 × 40',
  '20 × 60',
  '20 × 80',
  '30 × 10',
  '30 × 30',
  '30 × 50',
  '30 × 70',
  '30 × 90',
  '40 × 20',
  '40 × 40',
  '40 × 60',
  '40 × 80',
  '50 × 10',
  '50 × 30',
  '50 × 50',
  '50 × 70',
  '50 × 90',
  '60 × 20',
  '60 × 40',
  '60 × 60',
  '60 × 80',
  '70 × 10',
  '70 × 30',
  '70 × 50',
  '70 × 70',
  '70 × 90',
  '80 × 20',
  '80 × 40',
  '80 × 60',
  '80 × 80',
  '90 × 10',
  '90 × 30',
  '90 × 50',
  '90 × 70',
  '90 × 90',
];

const flag1Round3Pool1Answers = [
  '100',
  '300',
  '500',
  '700',
  '900',
  '400',
  '800',
  '1200',
  '1600',
  '300',
  '900',
  '1500',
  '2100',
  '2700',
  '800',
  '1600',
  '2400',
  '3200',
  '500',
  '1500',
  '2500',
  '3500',
  '4500',
  '1200',
  '2400',
  '3600',
  '4800',
  '700',
  '2100',
  '3500',
  '4900',
  '6300',
  '1600',
  '3200',
  '4800',
  '6400',
  '900',
  '2700',
  '4500',
  '6300',
  '8100',
];

const flag1Round3Pool2 = [
  '20 × 10',
  '40 × 10',
  '60 × 10',
  '80 × 10',
  '10 × 20',
  '30 × 20',
  '50 × 20',
  '70 × 20',
  '90 × 20',
  '20 × 30',
  '40 × 30',
  '60 × 30',
  '80 × 30',
  '10 × 40',
  '30 × 40',
  '50 × 40',
  '70 × 40',
  '90 × 40',
  '20 × 50',
  '40 × 50',
  '60 × 50',
  '80 × 50',
  '10 × 60',
  '30 × 60',
  '50 × 60',
  '70 × 60',
  '90 × 60',
  '20 × 70',
  '40 × 70',
  '60 × 70',
  '80 × 70',
  '10 × 80',
  '30 × 80',
  '50 × 80',
  '70 × 80',
  '90 × 80',
  '20 × 90',
  '40 × 90',
  '60 × 90',
  '80 × 90',
];

const flag1Round3Pool2Answers = [
  '200',
  '400',
  '600',
  '800',
  '200',
  '600',
  '1000',
  '1400',
  '1800',
  '600',
  '1200',
  '1800',
  '2400',
  '400',
  '1200',
  '2000',
  '2800',
  '3600',
  '1000',
  '2000',
  '3000',
  '4000',
  '600',
  '1800',
  '3000',
  '4200',
  '5400',
  '1400',
  '2800',
  '4200',
  '5600',
  '800',
  '2400',
  '4000',
  '5600',
  '7200',
  '1800',
  '3600',
  '5400',
  '7200',
];

const flag1Round4Pool1 = [
  '10 × 10',
  '30 × 10',
  '50 × 10',
  '70 × 10',
  '90 × 10',
  '20 × 20',
  '40 × 20',
  '60 × 20',
  '80 × 20',
  '10 × 30',
  '30 × 30',
  '50 × 30',
  '70 × 30',
  '90 × 30',
  '20 × 40',
  '40 × 40',
  '60 × 40',
  '80 × 40',
  '10 × 50',
  '30 × 50',
  '50 × 50',
  '70 × 50',
  '90 × 50',
  '20 × 60',
  '40 × 60',
  '60 × 60',
  '80 × 60',
  '10 × 70',
  '30 × 70',
  '50 × 70',
  '70 × 70',
  '90 × 70',
  '20 × 80',
  '40 × 80',
  '60 × 80',
  '80 × 80',
  '10 × 90',
  '30 × 90',
  '50 × 90',
  '70 × 90',
  '90 × 90',
];

const flag1Round4Pool1Answers = [
  '100',
  '300',
  '500',
  '700',
  '900',
  '400',
  '800',
  '1200',
  '1600',
  '300',
  '900',
  '1500',
  '2100',
  '2700',
  '800',
  '1600',
  '2400',
  '3200',
  '500',
  '1500',
  '2500',
  '3500',
  '4500',
  '1200',
  '2400',
  '3600',
  '4800',
  '700',
  '2100',
  '3500',
  '4900',
  '6300',
  '1600',
  '3200',
  '4800',
  '6400',
  '900',
  '2700',
  '4500',
  '6300',
  '8100',
];

const flag1Round4Pool2 = [
  '10 × 20',
  '10 × 40',
  '10 × 60',
  '10 × 80',
  '20 × 10',
  '20 × 30',
  '20 × 50',
  '20 × 70',
  '20 × 90',
  '30 × 20',
  '30 × 40',
  '30 × 60',
  '30 × 80',
  '40 × 10',
  '40 × 30',
  '40 × 50',
  '40 × 70',
  '40 × 90',
  '50 × 20',
  '50 × 40',
  '50 × 60',
  '50 × 80',
  '60 × 10',
  '60 × 30',
  '60 × 50',
  '60 × 70',
  '60 × 90',
  '70 × 20',
  '70 × 40',
  '70 × 60',
  '70 × 80',
  '80 × 10',
  '80 × 30',
  '80 × 50',
  '80 × 70',
  '80 × 90',
  '90 × 20',
  '90 × 40',
  '90 × 60',
  '90 × 80',
];

const flag1Round4Pool2Answers = [
  '200',
  '400',
  '600',
  '800',
  '200',
  '600',
  '1000',
  '1400',
  '1800',
  '600',
  '1200',
  '1800',
  '2400',
  '400',
  '1200',
  '2000',
  '2800',
  '3600',
  '1000',
  '2000',
  '3000',
  '4000',
  '600',
  '1800',
  '3000',
  '4200',
  '5400',
  '1400',
  '2800',
  '4200',
  '5600',
  '800',
  '2400',
  '4000',
  '5600',
  '7200',
  '1800',
  '3600',
  '5400',
  '7200',
];

const flag2Round1Layer1TopEQs = [
  '6 × 8',
  '2 × 7',
  '4 × 6',
  '7 × 9',
  '2 × 3',
  '5 × 7',
  '3 × 5',
  '3 × 7',
  '4 × 9',
];

const flag2Round1Layer1BottomAnswers = [
  '8 × 6',
  '7 × 2',
  '6 × 4',
  '9 × 7',
  '3 × 2',
  '7 × 5',
  '5 × 3',
  '7 × 3',
  '9 × 4',
];

const flag2Round1Layer2TopEQs = [
  '2 × 4',
  '5 × 8',
  '3 × 4',
  '6 × 7',
  '2 × 5',
  '7 × 8',
  '3 × 9',
  '4 × 8',
  '3 × 6',
];

const flag2Round1Layer2BottomAnswers = [
  '4 × 2',
  '8 × 5',
  '4 × 3',
  '7 × 6',
  '5 × 2',
  '8 × 7',
  '9 × 3',
  '8 × 4',
  '6 × 3',
];

const flag2Round1Layer3TopEQs = [
  '6 × 9',
  '2 × 6',
  '5 × 9',
  '2 × 8',
  '4 × 7',
  '7 × 9',
  '6 × 7',
  '4 × 9',
  '4 × 8',
];

const flag2Round1Layer3BottomAnswers = [
  '9 × 6',
  '6 × 2',
  '9 × 5',
  '8 × 2',
  '7 × 4',
  '9 × 7',
  '7 × 6',
  '9 × 4',
  '8 × 4',
];

const flag2Round1Layer4TopEQs = [
  '2 × 9',
  '3 × 8',
  '4 × 5',
  '5 × 6',
  '8 × 9',
  '6 × 8',
  '7 × 8',
  '5 × 7',
  '6 × 9',
];

const flag2Round1Layer4BottomAnswers = [
  '9 × 2',
  '8 × 3',
  '5 × 4',
  '6 × 5',
  '9 × 8',
  '8 × 6',
  '8 × 7',
  '7 × 5',
  '9 × 6',
];

const flag2Round2Layer1TopEQs = [
  '3 × 9',
  '2 × 3',
  '2 × 8',
  '8 × 9',
  '3 × 4',
  '5 × 8',
  '6 × 7',
  '3 × 5',
  '7 × 8',
];

const flag2Round2Layer1BottomAnswers = [
  '9 × 3',
  '3 × 2',
  '8 × 2',
  '9 × 8',
  '4 × 3',
  '8 × 5',
  '7 × 6',
  '5 × 3',
  '8 × 7',
];

const flag2Round2Layer2TopEQs = [
  '2 × 4',
  '4 × 6',
  '2 × 7',
  '6 × 8',
  '3 × 7',
  '5 × 9',
  '2 × 5',
  '4 × 9',
  '3 × 6',
];

const flag2Round2Layer2BottomAnswers = [
  '4 × 2',
  '6 × 4',
  '7 × 2',
  '8 × 6',
  '7 × 3',
  '9 × 5',
  '5 × 2',
  '9 × 4',
  '6 × 3',
];

const flag2Round2Layer3TopEQs = [
  '7 × 9',
  '2 × 6',
  '4 × 7',
  '6 × 9',
  '5 × 6',
  '8 × 9',
  '7 × 8',
  '6 × 7',
  '4 × 7',
];

const flag2Round2Layer3BottomAnswers = [
  '9 × 7',
  '6 × 2',
  '7 × 4',
  '9 × 6',
  '6 × 5',
  '9 × 8',
  '8 × 7',
  '7 × 6',
  '7 × 4',
];

const flag2Round2Layer4TopEQs = [
  '3 × 8',
  '2 × 9',
  '4 × 5',
  '5 × 7',
  '4 × 8',
  '4 × 9',
  '6 × 9',
  '7 × 9',
  '6 × 8',
];

const flag2Round2Layer4BottomAnswers = [
  '8 × 3',
  '9 × 2',
  '5 × 4',
  '7 × 5',
  '8 × 4',
  '9 × 4',
  '9 × 6',
  '9 × 7',
  '8 × 6',
];

const flag3Round1Pool1 = [
  '11 × 2',
  '21 × 2',
  '31 × 2',
  '41 × 2',
  '51 × 2',
  '61 × 2',
  '71 × 2',
  '81 × 2',
  '91 × 2',
  '11 × 3',
  '21 × 3',
  '31 × 3',
  '41 × 3',
  '51 × 3',
  '61 × 3',
  '71 × 3',
  '81 × 3',
  '91 × 3',
  '11 × 4',
  '21 × 4',
  '31 × 4',
  '41 × 4',
  '51 × 4',
  '61 × 4',
  '71 × 4',
  '81 × 4',
  '91 × 4',
  '11 × 5',
  '21 × 5',
  '31 × 5',
  '41 × 5',
  '51 × 5',
  '61 × 5',
  '71 × 5',
  '81 × 5',
  '91 × 5',
  '11 × 6',
  '21 × 6',
  '31 × 6',
  '41 × 6',
  '51 × 6',
  '61 × 6',
  '71 × 6',
  '81 × 6',
  '91 × 6',
  '11 × 7',
  '21 × 7',
  '31 × 7',
  '41 × 7',
  '51 × 7',
  '61 × 7',
  '71 × 7',
  '81 × 7',
  '91 × 7',
  '11 × 8',
  '21 × 8',
  '31 × 8',
  '41 × 8',
  '51 × 8',
  '61 × 8',
  '71 × 8',
  '81 × 8',
  '91 × 8',
  '11 × 9',
  '21 × 9',
  '31 × 9',
  '41 × 9',
  '51 × 9',
  '61 × 9',
  '71 × 9',
  '81 × 9',
  '91 × 9',
];

const flag3Round1Pool1Answers = [
  '22',
  '42',
  '62',
  '82',
  '102',
  '122',
  '142',
  '162',
  '182',
  '33',
  '63',
  '93',
  '123',
  '153',
  '183',
  '213',
  '243',
  '273',
  '44',
  '84',
  '124',
  '164',
  '204',
  '244',
  '284',
  '324',
  '364',
  '55',
  '105',
  '155',
  '205',
  '255',
  '305',
  '355',
  '405',
  '455',
  '66',
  '126',
  '186',
  '246',
  '306',
  '366',
  '426',
  '486',
  '546',
  '77',
  '147',
  '217',
  '287',
  '357',
  '427',
  '497',
  '567',
  '637',
  '88',
  '168',
  '248',
  '328',
  '408',
  '488',
  '568',
  '648',
  '728',
  '99',
  '189',
  '279',
  '369',
  '459',
  '549',
  '639',
  '729',
  '819',
];

const flag3Round1Pool2 = [
  '12 × 2',
  '22 × 2',
  '32 × 2',
  '42 × 2',
  '52 × 2',
  '62 × 2',
  '72 × 2',
  '82 × 2',
  '92 × 2',
  '12 × 3',
  '22 × 3',
  '32 × 3',
  '42 × 3',
  '52 × 3',
  '62 × 3',
  '72 × 3',
  '82 × 3',
  '92 × 3',
  '12 × 4',
  '22 × 4',
  '32 × 4',
  '42 × 4',
  '52 × 4',
  '62 × 4',
  '72 × 4',
  '82 × 4',
  '92 × 4',
  '13 × 2',
  '23 × 2',
  '33 × 2',
  '43 × 2',
  '53 × 2',
  '63 × 2',
  '73 × 2',
  '83 × 2',
  '93 × 2',
  '13 × 3',
  '23 × 3',
  '33 × 3',
  '43 × 3',
  '53 × 3',
  '63 × 3',
  '73 × 3',
  '83 × 3',
  '93 × 3',
  '14 × 2',
  '24 × 2',
  '34 × 2',
  '44 × 2',
  '54 × 2',
  '64 × 2',
  '74 × 2',
  '84 × 2',
  '94 × 2',
];

const flag3Round1Pool2Answers = [
  '24',
  '44',
  '64',
  '84',
  '104',
  '124',
  '144',
  '164',
  '184',
  '36',
  '66',
  '96',
  '126',
  '156',
  '186',
  '216',
  '246',
  '276',
  '48',
  '88',
  '128',
  '168',
  '208',
  '248',
  '288',
  '328',
  '368',
  '26',
  '46',
  '66',
  '86',
  '106',
  '126',
  '146',
  '166',
  '186',
  '39',
  '69',
  '99',
  '129',
  '159',
  '189',
  '219',
  '249',
  '279',
  '28',
  '48',
  '68',
  '88',
  '108',
  '128',
  '148',
  '168',
  '188',
];

const flag4Round1Layer1TopEQs = [
  '10 × 1',
  '10 × 3',
  '10 × 4',
  '10 × 5',
  '10 × 6',
  '10 × 7',
  '10 × 8',
  '10 × 9',
  '20 × 2',
];

const flag14Round1Layer1TopEQs = [
  '1 × 10',
  '3 × 10',
  '4 × 10',
  '5 × 10',
  '6 × 10',
  '7 × 10',
  '8 × 10',
  '9 × 10',
  '2 × 20',
];

const flag4Round1Layer1BottomAnswers = [
  '10',
  '30',
  '40',
  '50',
  '60',
  '70',
  '80',
  '90',
  '40',
];

const flag4Round1Layer2TopEQs = [
  '20 × 3',
  '20 × 4',
  '20 × 5',
  '20 × 6',
  '20 × 7',
  '20 × 8',
  '20 × 9',
  '30 × 2',
  '30 × 3',
];

const flag14Round1Layer2TopEQs = [
  '3 × 20',
  '4 × 20',
  '5 × 20',
  '6 × 20',
  '7 × 20',
  '8 × 20',
  '9 × 20',
  '2 × 30',
  '3 × 30',
];

const flag4Round1Layer2BottomAnswers = [
  '60',
  '80',
  '100',
  '120',
  '140',
  '160',
  '180',
  '60',
  '90',
];

const flag4Round1Layer3TopEQs = [
  '30 × 4',
  '30 × 5',
  '30 × 6',
  '30 × 7',
  '30 × 8',
  '30 × 9',
  '40 × 1',
  '40 × 3',
  '40 × 4',
];

const flag14Round1Layer3TopEQs = [
  '4 × 30',
  '5 × 30',
  '6 × 30',
  '7 × 30',
  '8 × 30',
  '9 × 30',
  '1 × 40',
  '3 × 40',
  '4 × 40',
];

const flag4Round1Layer3BottomAnswers = [
  '120',
  '150',
  '180',
  '210',
  '240',
  '270',
  '40',
  '120',
  '160',
];

const flag4Round1Layer4TopEQs = [
  '40 × 5',
  '40 × 6',
  '40 × 7',
  '40 × 8',
  '40 × 9',
  '50 × 2',
  '50 × 3',
  '50 × 4',
  '50 × 5',
];

const flag14Round1Layer4TopEQs = [
  '5 × 40',
  '6 × 40',
  '7 × 40',
  '8 × 40',
  '9 × 40',
  '2 × 50',
  '3 × 50',
  '4 × 50',
  '5 × 50',
];

const flag4Round1Layer4BottomAnswers = [
  '200',
  '240',
  '280',
  '320',
  '360',
  '100',
  '150',
  '200',
  '250',
];

const flag4Round2Layer1TopEQs = [
  '50 × 6',
  '50 × 7',
  '50 × 8',
  '50 × 9',
  '60 × 1',
  '60 × 3',
  '60 × 4',
  '60 × 5',
  '60 × 6',
];

const flag14Round2Layer1TopEQs = [
  '6 × 50',
  '7 × 50',
  '8 × 50',
  '9 × 50',
  '1 × 60',
  '3 × 60',
  '4 × 60',
  '5 × 60',
  '6 × 60',
];

const flag4Round2Layer1BottomAnswers = [
  '300',
  '350',
  '400',
  '450',
  '60',
  '180',
  '240',
  '300',
  '360',
];

const flag4Round2Layer2TopEQs = [
  '60 × 7',
  '60 × 8',
  '60 × 9',
  '70 × 2',
  '70 × 3',
  '70 × 4',
  '70 × 5',
  '70 × 6',
  '70 × 7',
];

const flag14Round2Layer2TopEQs = [
  '7 × 60',
  '8 × 60',
  '9 × 60',
  '2 × 70',
  '3 × 70',
  '4 × 70',
  '5 × 70',
  '6 × 70',
  '7 × 70',
];

const flag4Round2Layer2BottomAnswers = [
  '420',
  '480',
  '540',
  '140',
  '210',
  '280',
  '350',
  '420',
  '490',
];

const flag4Round2Layer3TopEQs = [
  '70 × 8',
  '70 × 9',
  '80 × 1',
  '80 × 3',
  '80 × 4',
  '80 × 5',
  '80 × 6',
  '80 × 7',
  '80 × 8',
];

const flag14Round2Layer3TopEQs = [
  '8 × 70',
  '9 × 70',
  '1 × 80',
  '3 × 80',
  '4 × 80',
  '5 × 80',
  '6 × 80',
  '7 × 80',
  '8 × 80',
];

const flag4Round2Layer3BottomAnswers = [
  '560',
  '630',
  '80',
  '240',
  '320',
  '400',
  '480',
  '560',
  '640',
];

const flag4Round2Layer4TopEQs = [
  '80 × 9',
  '90 × 2',
  '90 × 3',
  '90 × 4',
  '90 × 5',
  '90 × 6',
  '90 × 7',
  '90 × 8',
  '90 × 9',
];

const flag14Round2Layer4TopEQs = [
  '9 × 80',
  '2 × 90',
  '3 × 90',
  '4 × 90',
  '5 × 90',
  '6 × 90',
  '7 × 90',
  '8 × 90',
  '9 × 90',
];

const flag4Round2Layer4BottomAnswers = [
  '720',
  '180',
  '270',
  '360',
  '450',
  '540',
  '630',
  '720',
  '810',
];

const flag4Round3Pool1 = [
  '10 × 1',
  '10 × 3',
  '10 × 5',
  '10 × 7',
  '10 × 9',
  '20 × 2',
  '20 × 4',
  '20 × 6',
  '20 × 8',
  '30 × 1',
  '30 × 3',
  '30 × 5',
  '30 × 7',
  '30 × 9',
  '40 × 2',
  '40 × 4',
  '40 × 6',
  '40 × 8',
  '50 × 1',
  '50 × 3',
  '50 × 5',
  '50 × 7',
  '50 × 9',
  '60 × 2',
  '60 × 4',
  '60 × 6',
  '60 × 8',
  '70 × 1',
  '70 × 3',
  '70 × 5',
  '70 × 7',
  '70 × 9',
  '80 × 2',
  '80 × 4',
  '80 × 6',
  '80 × 8',
  '90 × 1',
  '90 × 3',
  '90 × 5',
  '90 × 7',
  '90 × 9',
];

const flag4Round3Pool1Answers = [
  '10',
  '30',
  '50',
  '70',
  '90',
  '40',
  '80',
  '120',
  '160',
  '30',
  '90',
  '150',
  '210',
  '270',
  '80',
  '160',
  '240',
  '320',
  '50',
  '150',
  '250',
  '350',
  '450',
  '120',
  '240',
  '360',
  '480',
  '70',
  '210',
  '350',
  '490',
  '630',
  '160',
  '320',
  '480',
  '640',
  '90',
  '270',
  '450',
  '630',
  '810',
];

const flag4Round3Pool2 = [
  '2 × 10',
  '4 × 10',
  '6 × 10',
  '8 × 10',
  '1 × 20',
  '3 × 20',
  '5 × 20',
  '7 × 20',
  '9 × 20',
  '2 × 30',
  '4 × 30',
  '6 × 30',
  '8 × 30',
  '1 × 40',
  '3 × 40',
  '5 × 40',
  '7 × 40',
  '9 × 40',
  '2 × 50',
  '4 × 50',
  '6 × 50',
  '8 × 50',
  '1 × 60',
  '3 × 60',
  '5 × 60',
  '7 × 60',
  '9 × 60',
  '2 × 70',
  '4 × 70',
  '6 × 70',
  '8 × 70',
  '1 × 80',
  '3 × 80',
  '5 × 80',
  '7 × 80',
  '9 × 80',
  '2 × 90',
  '4 × 90',
  '6 × 90',
  '8 × 90',
];

const flag4Round3Pool2Answers = [
  '20',
  '40',
  '60',
  '80',
  '20',
  '60',
  '100',
  '140',
  '180',
  '60',
  '120',
  '180',
  '240',
  '40',
  '120',
  '200',
  '280',
  '360',
  '100',
  '200',
  '300',
  '400',
  '60',
  '180',
  '300',
  '420',
  '540',
  '140',
  '280',
  '420',
  '560',
  '80',
  '240',
  '400',
  '560',
  '720',
  '180',
  '360',
  '540',
  '720',
];

const flag4Round4Pool1 = [
  '1 × 10',
  '3 × 10',
  '5 × 10',
  '7 × 10',
  '9 × 10',
  '2 × 20',
  '4 × 20',
  '6 × 20',
  '8 × 20',
  '1 × 30',
  '3 × 30',
  '5 × 30',
  '7 × 30',
  '9 × 30',
  '2 × 40',
  '4 × 40',
  '6 × 40',
  '8 × 40',
  '1 × 50',
  '3 × 50',
  '5 × 50',
  '7 × 50',
  '9 × 50',
  '2 × 60',
  '4 × 60',
  '6 × 60',
  '8 × 60',
  '1 × 70',
  '3 × 70',
  '5 × 70',
  '7 × 70',
  '9 × 70',
  '2 × 80',
  '4 × 80',
  '6 × 80',
  '8 × 80',
  '1 × 90',
  '3 × 90',
  '5 × 90',
  '7 × 90',
  '9 × 90',
];

const flag4Round4Pool1Answers = [
  '10',
  '30',
  '50',
  '70',
  '90',
  '40',
  '80',
  '120',
  '160',
  '30',
  '90',
  '150',
  '210',
  '270',
  '80',
  '160',
  '240',
  '320',
  '50',
  '150',
  '250',
  '350',
  '450',
  '120',
  '240',
  '360',
  '480',
  '70',
  '210',
  '350',
  '490',
  '630',
  '160',
  '320',
  '480',
  '640',
  '90',
  '270',
  '450',
  '630',
  '810',
];

const flag4Round4Pool2 = [
  '10 × 2',
  '10 × 4',
  '10 × 6',
  '10 × 8',
  '20 × 1',
  '20 × 3',
  '20 × 5',
  '20 × 7',
  '20 × 9',
  '30 × 2',
  '30 × 4',
  '30 × 6',
  '30 × 8',
  '40 × 1',
  '40 × 3',
  '40 × 5',
  '40 × 7',
  '40 × 9',
  '50 × 2',
  '50 × 4',
  '50 × 6',
  '50 × 8',
  '60 × 1',
  '60 × 3',
  '60 × 5',
  '60 × 7',
  '60 × 9',
  '70 × 2',
  '70 × 4',
  '70 × 6',
  '70 × 8',
  '80 × 1',
  '80 × 3',
  '80 × 5',
  '80 × 7',
  '80 × 9',
  '90 × 2',
  '90 × 4',
  '90 × 6',
  '90 × 8',
];

const flag4Round4Pool2Answers = [
  '20',
  '40',
  '60',
  '80',
  '20',
  '60',
  '100',
  '140',
  '180',
  '60',
  '120',
  '180',
  '240',
  '40',
  '120',
  '200',
  '280',
  '360',
  '100',
  '200',
  '300',
  '400',
  '60',
  '180',
  '300',
  '420',
  '540',
  '140',
  '280',
  '420',
  '560',
  '80',
  '240',
  '400',
  '560',
  '720',
  '180',
  '360',
  '540',
  '720',
];

const flag6Round1Layer1TopEQs = [
  '2 × 2',
  '2 × 3',
  '2 × 4',
  '2 × 5',
  '2 × 6',
  '2 × 7',
  '2 × 8',
  '2 × 9',
  '3 × 3',
];

const flag6Round1Layer1BottomAnswers = [
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '9',
];

const flag6Round1Layer1FactSounds = [
  'f22',
  'f23',
  'f24',
  'f25',
  'f26',
  'f27',
  'f28',
  'f29',
  'f33',
];

const flag6Round1Layer1FactAnswerSounds = [
  'fa22',
  'fa23',
  'fa24',
  'fa25',
  'fa26',
  'fa27',
  'fa28',
  'fa29',
  'fa33',
];

const flag6Round1Layer2TopEQs = [
  '3 × 4',
  '3 × 5',
  '3 × 6',
  '3 × 7',
  '3 × 8',
  '3 × 9',
  '4 × 4',
  '4 × 5',
  '4 × 6',
];

const flag6Round1Layer2BottomAnswers = [
  '12',
  '15',
  '18',
  '21',
  '24',
  '27',
  '16',
  '20',
  '24',
];

const flag6Round1Layer2FactSounds = [
  'f34',
  'f35',
  'f36',
  'f37',
  'f38',
  'f39',
  'f44',
  'f45',
  'f46',
];

const flag6Round1Layer2FactAnswerSounds = [
  'fa34',
  'fa35',
  'fa36',
  'fa37',
  'fa38',
  'fa39',
  'fa44',
  'fa45',
  'fa46',
];

const flag6Round1Layer3TopEQs = [
  '4 × 7',
  '4 × 8',
  '4 × 9',
  '5 × 5',
  '5 × 6',
  '5 × 7',
  '5 × 8',
  '5 × 9',
  '6 × 6',
];

const flag6Round1Layer3BottomAnswers = [
  '28',
  '32',
  '36',
  '25',
  '30',
  '35',
  '40',
  '45',
  '36',
];

const flag6Round1Layer3FactSounds = [
  'f47',
  'f48',
  'f49',
  'f55',
  'f56',
  'f57',
  'f58',
  'f59',
  'f66',
];

const flag6Round1Layer3FactAnswerSounds = [
  'fa47',
  'fa48',
  'fa49',
  'fa55',
  'fa56',
  'fa57',
  'fa58',
  'fa59',
  'fa66',
];

const flag6Round1Layer4TopEQs = [
  '6 × 7',
  '6 × 8',
  '6 × 9',
  '7 × 7',
  '7 × 8',
  '7 × 9',
  '8 × 8',
  '8 × 9',
  '9 × 9',
];

const flag6Round1Layer4BottomAnswers = [
  '42',
  '48',
  '54',
  '49',
  '56',
  '63',
  '64',
  '72',
  '81',
];

const flag6Round1Layer4FactSounds = [
  'f67',
  'f68',
  'f69',
  'f77',
  'f78',
  'f79',
  'f88',
  'f89',
  'f99',
];

const flag6Round1Layer4FactAnswerSounds = [
  'fa67',
  'fa68',
  'fa69',
  'fa77',
  'fa78',
  'fa79',
  'fa88',
  'fa89',
  'fa99',
];

const flag6Round2Layer1TopEQs = [
  '2 × 2',
  '2 × 6',
  '3 × 4',
  '3 × 7',
  '4 × 5',
  '4 × 7',
  '5 × 7',
  '6 × 8',
  '7 × 9',
];

const flag6Round2Layer1BottomAnswers = [
  '4',
  '12',
  '12',
  '21',
  '20',
  '28',
  '35',
  '48',
  '63',
];

const flag6Round2Layer1FactSounds = [
  'f22',
  'f26',
  'f34',
  'f37',
  'f45',
  'f47',
  'f57',
  'f68',
  'f79',
];

const flag6Round2Layer1FactAnswerSounds = [
  'fa22',
  'fa26',
  'fa34',
  'fa37',
  'fa45',
  'fa47',
  'fa57',
  'fa68',
  'fa79',
];

const flag6Round2Layer2TopEQs = [
  '2 × 3',
  '2 × 4',
  '3 × 5',
  '3 × 6',
  '3 × 8',
  '4 × 4',
  '5 × 8',
  '6 × 7',
  '8 × 9',
];

const flag6Round2Layer2BottomAnswers = [
  '6',
  '8',
  '15',
  '18',
  '24',
  '16',
  '40',
  '42',
  '72',
];

const flag6Round2Layer2FactSounds = [
  'f23',
  'f24',
  'f35',
  'f36',
  'f38',
  'f44',
  'f58',
  'f67',
  'f89',
];

const flag6Round2Layer2FactAnswerSounds = [
  'fa23',
  'fa24',
  'fa35',
  'fa36',
  'fa38',
  'fa44',
  'fa58',
  'fa67',
  'fa89',
];

const flag6Round2Layer3TopEQs = [
  '2 × 5',
  '2 × 7',
  '3 × 3',
  '4 × 6',
  '4 × 8',
  '5 × 9',
  '6 × 6',
  '7 × 7',
  '8 × 8',
];

const flag6Round2Layer3BottomAnswers = [
  '10',
  '14',
  '9',
  '24',
  '32',
  '45',
  '36',
  '49',
  '64',
];

const flag6Round2Layer3FactSounds = [
  'f25',
  'f27',
  'f33',
  'f46',
  'f48',
  'f59',
  'f66',
  'f77',
  'f88',
];

const flag6Round2Layer3FactAnswerSounds = [
  'fa25',
  'fa27',
  'fa33',
  'fa46',
  'fa48',
  'fa59',
  'fa66',
  'fa77',
  'fa88',
];

const flag6Round2Layer4TopEQs = [
  '2 × 8',
  '2 × 9',
  '3 × 9',
  '4 × 9',
  '5 × 5',
  '5 × 6',
  '6 × 9',
  '7 × 8',
  '9 × 9',
];

const flag6Round2Layer4BottomAnswers = [
  '16',
  '18',
  '27',
  '36',
  '25',
  '30',
  '54',
  '56',
  '81',
];

const flag6Round2Layer4FactSounds = [
  'f28',
  'f29',
  'f39',
  'f49',
  'f55',
  'f56',
  'f69',
  'f78',
  'f99',
];

const flag6Round2Layer4FactAnswerSounds = [
  'fa28',
  'fa29',
  'fa39',
  'fa49',
  'fa55',
  'fa56',
  'fa69',
  'fa78',
  'fa99',
];

const flag6Round3Pool1 = [
  '2 × 2',
  '2 × 3',
  '2 × 4',
  '2 × 5',
  '2 × 6',
  '2 × 7',
  '2 × 8',
  '2 × 9',
  '3 × 3',
  '3 × 4',
  '3 × 5',
  '3 × 6',
  '3 × 7',
  '3 × 8',
  '3 × 9',
  '4 × 4',
  '4 × 5',
  '4 × 6',
  '4 × 7',
  '4 × 8',
  '4 × 9',
  '5 × 5',
  '5 × 6',
  '5 × 7',
  '5 × 8',
  '5 × 9',
  '6 × 6',
  '6 × 7',
  '6 × 8',
  '6 × 9',
  '7 × 7',
  '7 × 8',
  '7 × 9',
  '8 × 8',
  '8 × 9',
  '9 × 9',
];

const flag6Round3Pool1Answers = [
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '9',
  '12',
  '15',
  '18',
  '21',
  '24',
  '27',
  '16',
  '20',
  '24',
  '28',
  '32',
  '36',
  '25',
  '30',
  '35',
  '40',
  '45',
  '36',
  '42',
  '48',
  '54',
  '49',
  '56',
  '63',
  '64',
  '72',
  '81',
];

const flag6Round3SoundPool1 = [
  'f22',
  'f23',
  'f24',
  'f25',
  'f26',
  'f27',
  'f28',
  'f29',
  'f33',
  'f34',
  'f35',
  'f36',
  'f37',
  'f38',
  'f39',
  'f44',
  'f45',
  'f46',
  'f47',
  'f48',
  'f49',
  'f55',
  'f56',
  'f57',
  'f58',
  'f59',
  'f66',
  'f67',
  'f68',
  'f69',
  'f77',
  'f78',
  'f79',
  'f88',
  'f89',
  'f99',
];

const flag6Round3SoundWAnswerPool1 = [
  'fa22',
  'fa23',
  'fa24',
  'fa25',
  'fa26',
  'fa27',
  'fa28',
  'fa29',
  'fa33',
  'fa34',
  'fa35',
  'fa36',
  'fa37',
  'fa38',
  'fa39',
  'fa44',
  'fa45',
  'fa46',
  'fa47',
  'fa48',
  'fa49',
  'fa55',
  'fa56',
  'fa57',
  'fa58',
  'fa59',
  'fa66',
  'fa67',
  'fa68',
  'fa69',
  'fa77',
  'fa78',
  'fa79',
  'fa88',
  'fa89',
  'fa99',
];

const flag7TopEQs = [
  '2 × 2',
  '2 × 3',
  '2 × 4',
  '2 × 5',
  '2 × 6',
  '2 × 7',
  '2 × 8',
  '2 × 9',
  '3 × 3',
  '3 × 4',
  '3 × 5',
  '3 × 6',
  '3 × 7',
  '3 × 8',
  '3 × 9',
  '4 × 4',
  '4 × 5',
  '4 × 6',
  '4 × 7',
  '4 × 8',
  '4 × 9',
];

const flag7BottomAnswers = [
  '4',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '9',
  '12',
  '15',
  '18',
  '21',
  '24',
  '27',
  '16',
  '20',
  '24',
  '28',
  '32',
  '36',
];

const flag7FactSounds = [
  'f22',
  'f23',
  'f24',
  'f25',
  'f26',
  'f27',
  'f28',
  'f29',
  'f33',
  'f34',
  'f35',
  'f36',
  'f37',
  'f38',
  'f39',
  'f44',
  'f45',
  'f46',
  'f47',
  'f48',
  'f49',
];

const flag7FactAnswerSounds = [
  'fa22',
  'fa23',
  'fa24',
  'fa25',
  'fa26',
  'fa27',
  'fa28',
  'fa29',
  'fa33',
  'fa34',
  'fa35',
  'fa36',
  'fa37',
  'fa38',
  'fa39',
  'fa44',
  'fa45',
  'fa46',
  'fa47',
  'fa48',
  'fa49',
];

const flag8TopEQs = [
  '5 × 5',
  '5 × 6',
  '5 × 7',
  '5 × 8',
  '5 × 9',
  '6 × 6',
  '6 × 7',
  '6 × 8',
  '6 × 9',
  '7 × 7',
  '7 × 8',
  '7 × 9',
  '8 × 8',
  '8 × 9',
  '9 × 9',
];

const flag8BottomAnswers = [
  '25',
  '30',
  '35',
  '40',
  '45',
  '36',
  '42',
  '48',
  '54',
  '49',
  '56',
  '63',
  '64',
  '72',
  '81',
];

const flag8FactSounds = [
  'f55',
  'f56',
  'f57',
  'f58',
  'f59',
  'f66',
  'f67',
  'f68',
  'f69',
  'f77',
  'f78',
  'f79',
  'f88',
  'f89',
  'f99',
];

const flag8FactAnswerSounds = [
  'fa55',
  'fa56',
  'fa57',
  'fa58',
  'fa59',
  'fa66',
  'fa67',
  'fa68',
  'fa69',
  'fa77',
  'fa78',
  'fa79',
  'fa88',
  'fa89',
  'fa99',
];

const flag10Round1Layer1TopEQs = ['2 ÷ 1', '4 ÷ 1', '6 ÷ 1', '9 ÷ 1'];

const flag10Round1Layer1BottomAnswers = ['2', '4', '6', '9'];

const flag10Round1Layer2TopEQs = ['2 ÷ 1', '9 ÷ 1', '3 ÷ 1', '6 ÷ 1'];

const flag10Round1Layer2BottomAnswers = ['2', '9', '3', '6'];

const flag10Round1Layer3TopEQs = ['5 ÷ 1', '8 ÷ 1', '4 ÷ 1', '7 ÷ 1'];

const flag10Round1Layer3BottomAnswers = ['5', '8', '4', '7'];

const flag10Round1Layer4TopEQs = [
  '2 ÷ 1',
  '0 ÷ 9',
  '7 ÷ 1',
  '0 ÷ 1',
  '3 ÷ 3',
  '0 ÷ 2',
  '5 ÷ 1',
  '0 ÷ 6',
  '8 ÷ 1',
];

const flag10Round1Layer4BottomAnswers = [
  '2',
  '0',
  '7',
  '0',
  '1',
  '0',
  '5',
  '0',
  '8',
];

const flag10Round2Layer1TopEQs = ['9 ÷ 1', '4 ÷ 1', '2 ÷ 1', '5 ÷ 1'];

const flag10Round2Layer1BottomAnswers = ['9', '4', '2', '5'];

const flag10Round2Layer2TopEQs = [
  '0 ÷ 8',
  '9 ÷ 9',
  '0 ÷ 3',
  '8 ÷ 1',
  '0 ÷ 1',
  '1 ÷ 1',
  '3 ÷ 1',
  '0 ÷ 4',
  '6 ÷ 1',
];

const flag10Round2Layer2BottomAnswers = [
  '0',
  '1',
  '0',
  '8',
  '0',
  '1',
  '3',
  '0',
  '6',
];

const flag10Round2Layer3TopEQs = ['4 ÷ 1', '5 ÷ 1', '6 ÷ 1', '7 ÷ 1'];

const flag10Round2Layer3BottomAnswers = ['4', '5', '6', '7'];

const flag10Round2Layer4TopEQs = ['3 ÷ 1', '8 ÷ 1', '2 ÷ 1', '7 ÷ 1'];

const flag10Round2Layer4BottomAnswers = ['3', '8', '2', '7'];

const flag12Round1Layer1TopEQs = [
  '2 ÷ 2 = xP2 ÷ x = 2',
  '5 ÷ 5 = xP5 ÷ x = 5',
  '8 ÷ 8 = xP8 ÷ x = 8',
  '8 ÷ 4 = xP8 ÷ x = 4',
  '12 ÷ 6 = xP12 ÷ x = 6',
  '12 ÷ 4 = xP12 ÷ x = 4',
  '15 ÷ 5 = xP15 ÷ x = 5',
  '32 ÷ 8 = xP32 ÷ x = 8',
  '45 ÷ 9 = xP45 ÷ x = 9',
];

const flag12Round1Layer1BottomAnswers = [
  '1',
  '1',
  '1',
  '2',
  '2',
  '3',
  '3',
  '4',
  '5',
];

const flag12Round1Layer2TopEQs = [
  '4 ÷ 4 = xP4 ÷ x = 4',
  '9 ÷ 9 = xP9 ÷ x = 9',
  '6 ÷ 3 = xP6 ÷ x = 3',
  '16 ÷ 8 = xP16 ÷ x = 8',
  '14 ÷ 7 = xP14 ÷ x = 7',
  '21 ÷ 7 = xP21 ÷ x = 7',
  '54 ÷ 9 = xP54 ÷ x = 9',
  '35 ÷ 7 = xP35 ÷ x = 7',
  '56 ÷ 8 = xP56 ÷ x = 8',
];

const flag12Round1Layer2BottomAnswers = [
  '1',
  '1',
  '2',
  '2',
  '2',
  '3',
  '6',
  '5',
  '7',
];

const flag12Round2Layer1TopEQs = [
  '3 ÷ 3 = xP3 ÷ x = 3',
  '6 ÷ 6 = xP6 ÷ x = 6',
  '7 ÷ 7 = xP7 ÷ x = 7',
  '10 ÷ 5 = xP10 ÷ x = 5',
  '24 ÷ 8 = xP24 ÷ x = 8',
  '20 ÷ 5 = xP20 ÷ x = 5',
  '24 ÷ 6 = xP24 ÷ x = 6',
  '30 ÷ 6 = xP30 ÷ x = 6',
  '40 ÷ 8 = xP40 ÷ x = 8',
];

const flag12Round2Layer1BottomAnswers = [
  '1',
  '1',
  '1',
  '2',
  '3',
  '4',
  '4',
  '5',
  '5',
];

const flag12Round2Layer2TopEQs = [
  '18 ÷ 9 = xP18 ÷ x = 9',
  '18 ÷ 6 = xP18 ÷ x = 6',
  '27 ÷ 9 = xP27 ÷ x = 9',
  '28 ÷ 7 = xP28 ÷ x = 7',
  '36 ÷ 9 = xP36 ÷ x = 9',
  '42 ÷ 7 = xP42 ÷ x = 7',
  '48 ÷ 8 = xP48 ÷ x = 8',
  '63 ÷ 9 = xP63 ÷ x = 9',
  '72 ÷ 9 = xP72 ÷ x = 9',
];

const flag12Round2Layer2BottomAnswers = [
  '2',
  '3',
  '3',
  '4',
  '4',
  '6',
  '6',
  '7',
  '8',
];

const flag16Round1Layer1TopEQs = [
  '4 ÷ 2',
  '6 ÷ 2',
  '8 ÷ 2',
  '10 ÷ 2',
  '12 ÷ 2',
  '14 ÷ 2',
  '16 ÷ 2',
  '18 ÷ 2',
  '9 ÷ 3',
];

const flag16Round1Layer1BottomAnswers = [
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '3',
];

const flag16Round1Layer2TopEQs = [
  '12 ÷ 3',
  '15 ÷ 3',
  '18 ÷ 3',
  '21 ÷ 3',
  '24 ÷ 3',
  '27 ÷ 3',
  '16 ÷ 4',
  '20 ÷ 4',
  '24 ÷ 4',
];

const flag16Round1Layer2BottomAnswers = [
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '4',
  '5',
  '6',
];

const flag16Round1Layer3TopEQs = [
  '28 ÷ 4',
  '32 ÷ 4',
  '36 ÷ 4',
  '25 ÷ 5',
  '30 ÷ 5',
  '35 ÷ 5',
  '40 ÷ 5',
  '45 ÷ 5',
  '36 ÷ 6',
];

const flag16Round1Layer3BottomAnswers = [
  '7',
  '8',
  '9',
  '5',
  '6',
  '7',
  '8',
  '9',
  '6',
];

const flag16Round1Layer4TopEQs = [
  '42 ÷ 6',
  '48 ÷ 6',
  '54 ÷ 6',
  '49 ÷ 7',
  '56 ÷ 7',
  '63 ÷ 7',
  '64 ÷ 8',
  '72 ÷ 8',
  '81 ÷ 9',
];

const flag16Round1Layer4BottomAnswers = [
  '7',
  '8',
  '9',
  '7',
  '8',
  '9',
  '8',
  '9',
  '9',
];

const flag16Round2Layer1TopEQs = [
  '4 ÷ 2',
  '36 ÷ 4',
  '12 ÷ 3',
  '18 ÷ 2',
  '20 ÷ 4',
  '28 ÷ 4',
  '35 ÷ 5',
  '48 ÷ 6',
  '18 ÷ 3',
];

const flag16Round2Layer1BottomAnswers = [
  '2',
  '9',
  '4',
  '9',
  '5',
  '7',
  '7',
  '8',
  '6',
];

const flag16Round2Layer2TopEQs = [
  '12 ÷ 2',
  '24 ÷ 4',
  '15 ÷ 3',
  '63 ÷ 7',
  '24 ÷ 3',
  '16 ÷ 4',
  '40 ÷ 5',
  '42 ÷ 6',
  '72 ÷ 8',
];

const flag16Round2Layer2BottomAnswers = [
  '6',
  '6',
  '5',
  '9',
  '8',
  '4',
  '8',
  '7',
  '9',
];

const flag16Round2Layer3TopEQs = [
  '10 ÷ 2',
  '27 ÷ 3',
  '9 ÷ 3',
  '8 ÷ 2',
  '32 ÷ 4',
  '45 ÷ 5',
  '36 ÷ 6',
  '49 ÷ 7',
  '64 ÷ 8',
];

const flag16Round2Layer3BottomAnswers = [
  '5',
  '9',
  '3',
  '4',
  '8',
  '9',
  '6',
  '7',
  '8',
];

const flag16Round2Layer4TopEQs = [
  '16 ÷ 2',
  '21 ÷ 3',
  '14 ÷ 2',
  '6 ÷ 2',
  '25 ÷ 5',
  '30 ÷ 5',
  '54 ÷ 6',
  '56 ÷ 7',
  '81 ÷ 9',
];

const flag16Round2Layer4BottomAnswers = [
  '8',
  '7',
  '7',
  '3',
  '5',
  '6',
  '9',
  '8',
  '9',
];

const flag16Round3Pool1 = [
  '4 ÷ 2',
  '6 ÷ 2',
  '8 ÷ 2',
  '10 ÷ 2',
  '12 ÷ 2',
  '14 ÷ 2',
  '16 ÷ 2',
  '18 ÷ 2',
  '9 ÷ 3',
  '12 ÷ 3',
  '15 ÷ 3',
  '18 ÷ 3',
  '21 ÷ 3',
  '24 ÷ 3',
  '27 ÷ 3',
  '16 ÷ 4',
  '20 ÷ 4',
  '24 ÷ 4',
  '28 ÷ 4',
  '32 ÷ 4',
  '36 ÷ 4',
  '25 ÷ 5',
  '30 ÷ 5',
  '35 ÷ 5',
  '40 ÷ 5',
  '45 ÷ 5',
  '36 ÷ 6',
  '42 ÷ 6',
  '48 ÷ 6',
  '54 ÷ 6',
  '49 ÷ 7',
  '56 ÷ 7',
  '63 ÷ 7',
  '64 ÷ 8',
  '72 ÷ 8',
  '81 ÷ 9',
];

const flag16Round3Pool1Answers = [
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '5',
  '6',
  '7',
  '8',
  '9',
  '6',
  '7',
  '8',
  '9',
  '7',
  '8',
  '9',
  '8',
  '9',
  '9',
];

const sharedTEqValues = [0, 0, 0, 0, 0, 0, 0, 0, 0];

const sharedTEqSounds = ['', '', '', '', '', '', '', '', ''];

const sharedTEqSoundsWAnswer = ['', '', '', '', '', '', '', '', ''];

export const RULES_MUL_DIV_START_SECONDS = {
  flag0: flag0StartSeconds,
  flag1: flag1StartSeconds,
  flag2: flag2StartSeconds,
  flag3: flag3StartSeconds,
  flag4: flag4StartSeconds,
  flag5: flag5StartSeconds,
  flag6: flag6StartSeconds,
  flag7: flag7StartSeconds,
  flag8: flag8StartSeconds,
  flag10: flag10StartSeconds,
  flag11: flag11StartSeconds,
  flag12: flag12StartSeconds,
  flag13: flag13StartSeconds,
  flag14: flag14StartSeconds,
  flag15: flag15StartSeconds,
  flag16: flag16StartSeconds,
};

export const RULES_MUL_DIV_DATA = {
  flag0: {
    round1: {
      layer1: {
        topEQs: flag0Round1Layer1TopEQs,
        bottomAnswers: flag0Round1Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag0Round1Layer2TopEQs,
        bottomAnswers: flag0Round1Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag0Round1Layer3TopEQs,
        bottomAnswers: flag0Round1Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag0Round1Layer4TopEQs,
        bottomAnswers: flag0Round1Layer4BottomAnswers,
      },
    },
    round2: {
      layer1: {
        topEQs: flag0Round2Layer1TopEQs,
        bottomAnswers: flag0Round2Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag0Round2Layer2TopEQs,
        bottomAnswers: flag0Round2Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag0Round2Layer3TopEQs,
        bottomAnswers: flag0Round2Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag0Round2Layer4TopEQs,
        bottomAnswers: flag0Round2Layer4BottomAnswers,
      },
    },
  },
  flag1: {
    round1: {
      layer1: {
        topEQs: flag1Round1Layer1TopEQs,
        bottomAnswers: flag1Round1Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag1Round1Layer2TopEQs,
        bottomAnswers: flag1Round1Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag1Round1Layer3TopEQs,
        bottomAnswers: flag1Round1Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag1Round1Layer4TopEQs,
        bottomAnswers: flag1Round1Layer4BottomAnswers,
      },
    },
    round2: {
      layer1: {
        topEQs: flag1Round2Layer1TopEQs,
        bottomAnswers: flag1Round2Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag1Round2Layer2TopEQs,
        bottomAnswers: flag1Round2Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag1Round2Layer3TopEQs,
        bottomAnswers: flag1Round2Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag1Round2Layer4TopEQs,
        bottomAnswers: flag1Round2Layer4BottomAnswers,
      },
    },
    round3: {
      pool1: flag1Round3Pool1,
      pool1Answers: flag1Round3Pool1Answers,
      pool2: flag1Round3Pool2,
      pool2Answers: flag1Round3Pool2Answers,
    },
    round4: {
      pool1: flag1Round4Pool1,
      pool1Answers: flag1Round4Pool1Answers,
      pool2: flag1Round4Pool2,
      pool2Answers: flag1Round4Pool2Answers,
    },
  },
  flag2: {
    round1: {
      layer1: {
        topEQs: flag2Round1Layer1TopEQs,
        bottomAnswers: flag2Round1Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag2Round1Layer2TopEQs,
        bottomAnswers: flag2Round1Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag2Round1Layer3TopEQs,
        bottomAnswers: flag2Round1Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag2Round1Layer4TopEQs,
        bottomAnswers: flag2Round1Layer4BottomAnswers,
      },
    },
    round2: {
      layer1: {
        topEQs: flag2Round2Layer1TopEQs,
        bottomAnswers: flag2Round2Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag2Round2Layer2TopEQs,
        bottomAnswers: flag2Round2Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag2Round2Layer3TopEQs,
        bottomAnswers: flag2Round2Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag2Round2Layer4TopEQs,
        bottomAnswers: flag2Round2Layer4BottomAnswers,
      },
    },
  },
  flag3: {
    round1: {
      pool1: flag3Round1Pool1,
      pool1Answers: flag3Round1Pool1Answers,
      pool2: flag3Round1Pool2,
      pool2Answers: flag3Round1Pool2Answers,
    },
  },
  flag4: {
    round1: {
      layer1: {
        topEQs: flag4Round1Layer1TopEQs,
        bottomAnswers: flag4Round1Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag4Round1Layer2TopEQs,
        bottomAnswers: flag4Round1Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag4Round1Layer3TopEQs,
        bottomAnswers: flag4Round1Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag4Round1Layer4TopEQs,
        bottomAnswers: flag4Round1Layer4BottomAnswers,
      },
    },
    round2: {
      layer1: {
        topEQs: flag4Round2Layer1TopEQs,
        bottomAnswers: flag4Round2Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag4Round2Layer2TopEQs,
        bottomAnswers: flag4Round2Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag4Round2Layer3TopEQs,
        bottomAnswers: flag4Round2Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag4Round2Layer4TopEQs,
        bottomAnswers: flag4Round2Layer4BottomAnswers,
      },
    },
    round3: {
      pool1: flag4Round3Pool1,
      pool1Answers: flag4Round3Pool1Answers,
      pool2: flag4Round3Pool2,
      pool2Answers: flag4Round3Pool2Answers,
    },
    round4: {
      pool1: flag4Round4Pool1,
      pool1Answers: flag4Round4Pool1Answers,
      pool2: flag4Round4Pool2,
      pool2Answers: flag4Round4Pool2Answers,
    },
  },
  flag14: {
    round1: {
      layer1: {
        topEQs: flag14Round1Layer1TopEQs,
      },
      layer2: {
        topEQs: flag14Round1Layer2TopEQs,
      },
      layer3: {
        topEQs: flag14Round1Layer3TopEQs,
      },
      layer4: {
        topEQs: flag14Round1Layer4TopEQs,
      },
    },
    round2: {
      layer1: {
        topEQs: flag14Round2Layer1TopEQs,
      },
      layer2: {
        topEQs: flag14Round2Layer2TopEQs,
      },
      layer3: {
        topEQs: flag14Round2Layer3TopEQs,
      },
      layer4: {
        topEQs: flag14Round2Layer4TopEQs,
      },
    },
  },
  flag6: {
    round1: {
      layer1: {
        topEQs: flag6Round1Layer1TopEQs,
        bottomAnswers: flag6Round1Layer1BottomAnswers,
        factSounds: flag6Round1Layer1FactSounds,
        factAnswerSounds: flag6Round1Layer1FactAnswerSounds,
      },
      layer2: {
        topEQs: flag6Round1Layer2TopEQs,
        bottomAnswers: flag6Round1Layer2BottomAnswers,
        factSounds: flag6Round1Layer2FactSounds,
        factAnswerSounds: flag6Round1Layer2FactAnswerSounds,
      },
      layer3: {
        topEQs: flag6Round1Layer3TopEQs,
        bottomAnswers: flag6Round1Layer3BottomAnswers,
        factSounds: flag6Round1Layer3FactSounds,
        factAnswerSounds: flag6Round1Layer3FactAnswerSounds,
      },
      layer4: {
        topEQs: flag6Round1Layer4TopEQs,
        bottomAnswers: flag6Round1Layer4BottomAnswers,
        factSounds: flag6Round1Layer4FactSounds,
        factAnswerSounds: flag6Round1Layer4FactAnswerSounds,
      },
    },
    round2: {
      layer1: {
        topEQs: flag6Round2Layer1TopEQs,
        bottomAnswers: flag6Round2Layer1BottomAnswers,
        factSounds: flag6Round2Layer1FactSounds,
        factAnswerSounds: flag6Round2Layer1FactAnswerSounds,
      },
      layer2: {
        topEQs: flag6Round2Layer2TopEQs,
        bottomAnswers: flag6Round2Layer2BottomAnswers,
        factSounds: flag6Round2Layer2FactSounds,
        factAnswerSounds: flag6Round2Layer2FactAnswerSounds,
      },
      layer3: {
        topEQs: flag6Round2Layer3TopEQs,
        bottomAnswers: flag6Round2Layer3BottomAnswers,
        factSounds: flag6Round2Layer3FactSounds,
        factAnswerSounds: flag6Round2Layer3FactAnswerSounds,
      },
      layer4: {
        topEQs: flag6Round2Layer4TopEQs,
        bottomAnswers: flag6Round2Layer4BottomAnswers,
        factSounds: flag6Round2Layer4FactSounds,
        factAnswerSounds: flag6Round2Layer4FactAnswerSounds,
      },
    },
    round3: {
      pool1: flag6Round3Pool1,
      pool1Answers: flag6Round3Pool1Answers,
      soundPool1: flag6Round3SoundPool1,
      soundWAnswerPool1: flag6Round3SoundWAnswerPool1,
    },
  },
  flag7: {
    topEQs: flag7TopEQs,
    bottomAnswers: flag7BottomAnswers,
    factSounds: flag7FactSounds,
    factAnswerSounds: flag7FactAnswerSounds,
  },
  flag8: {
    topEQs: flag8TopEQs,
    bottomAnswers: flag8BottomAnswers,
    factSounds: flag8FactSounds,
    factAnswerSounds: flag8FactAnswerSounds,
  },
  flag10: {
    round1: {
      layer1: {
        topEQs: flag10Round1Layer1TopEQs,
        bottomAnswers: flag10Round1Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag10Round1Layer2TopEQs,
        bottomAnswers: flag10Round1Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag10Round1Layer3TopEQs,
        bottomAnswers: flag10Round1Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag10Round1Layer4TopEQs,
        bottomAnswers: flag10Round1Layer4BottomAnswers,
      },
    },
    round2: {
      layer1: {
        topEQs: flag10Round2Layer1TopEQs,
        bottomAnswers: flag10Round2Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag10Round2Layer2TopEQs,
        bottomAnswers: flag10Round2Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag10Round2Layer3TopEQs,
        bottomAnswers: flag10Round2Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag10Round2Layer4TopEQs,
        bottomAnswers: flag10Round2Layer4BottomAnswers,
      },
    },
  },
  flag12: {
    round1: {
      layer1: {
        topEQs: flag12Round1Layer1TopEQs,
        bottomAnswers: flag12Round1Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag12Round1Layer2TopEQs,
        bottomAnswers: flag12Round1Layer2BottomAnswers,
      },
    },
    round2: {
      layer1: {
        topEQs: flag12Round2Layer1TopEQs,
        bottomAnswers: flag12Round2Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag12Round2Layer2TopEQs,
        bottomAnswers: flag12Round2Layer2BottomAnswers,
      },
    },
  },
  flag16: {
    round1: {
      layer1: {
        topEQs: flag16Round1Layer1TopEQs,
        bottomAnswers: flag16Round1Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag16Round1Layer2TopEQs,
        bottomAnswers: flag16Round1Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag16Round1Layer3TopEQs,
        bottomAnswers: flag16Round1Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag16Round1Layer4TopEQs,
        bottomAnswers: flag16Round1Layer4BottomAnswers,
      },
    },
    round2: {
      layer1: {
        topEQs: flag16Round2Layer1TopEQs,
        bottomAnswers: flag16Round2Layer1BottomAnswers,
      },
      layer2: {
        topEQs: flag16Round2Layer2TopEQs,
        bottomAnswers: flag16Round2Layer2BottomAnswers,
      },
      layer3: {
        topEQs: flag16Round2Layer3TopEQs,
        bottomAnswers: flag16Round2Layer3BottomAnswers,
      },
      layer4: {
        topEQs: flag16Round2Layer4TopEQs,
        bottomAnswers: flag16Round2Layer4BottomAnswers,
      },
    },
    round3: {
      pool1: flag16Round3Pool1,
      pool1Answers: flag16Round3Pool1Answers,
    },
  },
  shared: {
    tEqValues: sharedTEqValues,
    tEqSounds: sharedTEqSounds,
    tEqSoundsWAnswer: sharedTEqSoundsWAnswer,
  },
};
